import { styled } from '@mui/system';
import { ListItem, ListItemText, Typography } from '@mui/material';

export const StyledListItem = styled(ListItem)(() => ({
  border: 0,
  '&:nth-of-type(odd)': {
    backgroundColor: 'white'
  }
}));

export const StyledListItemText = styled(ListItemText)(() => ({
  padding: '10px 0'
}));

export const LogTimeWrapper = styled('span')(() => ({
  '& p': {
    padding: '0 7px',
    fontSize: '0.875rem',
    fontWeight: '500'
  }
}));

export const LogItemWrapper = styled('div')(() => ({
  color: 'black',
  padding: '15px 10px 10px 5px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
}));

export const LogIconWrapper = styled('span')(({ theme }) => ({
  marginRight: theme.spacing(2),
  display: 'flex'
}));

export const UnclickableText = styled(Typography)(() => ({
  pointerEvents: 'none',
  textDecoration: 'none'
}));

export const HeaderContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const ActorText = styled('span')(({ theme }) => ({
  padding: '0 7px',
  fontSize: '0.875rem',
  fontWeight: '500',
  color: theme.palette.secondary.main
}));
